(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function () {

	//NEED TO PREVENT DESELECT OF SINGLE ITEM

	var currentParams = location.href.split('?')[1];
	var params = currentParams.split('&');
	var configData = JSON.parse(sessionStorage.getItem('configData'));

	if (configData == null || configData == undefined || configData == 'undefined') {
		var configData = {};
		configData.model = params[0].split('=')[1];
		configData.length = params[1].split('=')[1];
		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));
	}

	var $containers = $('.card-floorplan');

	configData.configStep = 'floor-plan';
	sessionStorage.setItem('configData', JSON.stringify(configData));
	localStorage.setItem('configData', JSON.stringify(configData));

	if ($containers.length <= 1) {
		setTimeout(function () {
			$containers[0].click();
			$($containers[0]).addClass('card-disabled');
		}, 350);
	}

	jQuery('.card-floorplan').on('click', function (e) {
		e.preventDefault();
		if ($(this).hasClass('card-disabled')) {
			return false;
		}

		$('.selected-card').children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
		$('.selected-card').removeClass('selected-card');

		$(this).addClass('selected-card');

		if (jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked')) {
			jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
			$(this).removeClass('selected-card');
		} else {
			jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', true);
		}

		var currentParams = location.href.split('?')[1];
		var selectedFloorplan = jQuery(this).attr('data-id');
		if (!currentParams.includes(selectedFloorplan)) {
			var newParams = currentParams + '&floorplan=' + selectedFloorplan;
		} else {
			newParams = currentParams;
		}

		var configData = JSON.parse(sessionStorage.getItem('configData'));

		configData.floorplan = selectedFloorplan;

		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));

		jQuery('.pl-navNextBtn, .btn-next').attr('href', '/configurator/tt/decor/' + buildURLParams());

		jQuery('.pl-navNextBtn, .btn-next').removeClass('disabled');
	});

	jQuery('.pl-zoom-modal-trigger').click(function (e) {
		imgToShow = $(this).children('img').attr('src');
		$('.pl-zoom-modal .pl-modal-content img').attr('src', imgToShow);
	});
});

},{}]},{},[1]);
